export function hideField(registerName, name) {
  if (this.state[registerName].isTypeGrid) {
    this.events.emit(`ecFormBuilder:fbGrid:${registerName}`, {
      name,
      hide: true,
    }); // event para fb-grid
    this.updateStateColumn(registerName, name, true);
  } else {
    this.events.emit(`ecFormBuilder:fbHidden:${registerName}:${name}`, {
      hide: true,
    }); // event para fb-hidden
    this.updateStateField(registerName, name, true);
  }

  this.events.emit('ecFormBuilder:hide', { registerName, name });
}

export function showField(registerName, name) {
  if (this.state[registerName].isTypeGrid) {
    this.events.emit(`ecFormBuilder:fbGrid:${registerName}`, {
      name,
      hide: false,
    }); // event para fb-grid
    this.updateStateColumn(registerName, name, false);
  } else {
    this.events.emit(`ecFormBuilder:fbHidden:${registerName}:${name}`, {
      hide: false,
    }); // event para fb-hidden
    this.updateStateField(registerName, name, false);
  }

  this.events.emit('ecFormBuilder:show', { registerName, name });
}

export function isHiddenField(registerName, name) {
  const found = (this.state[registerName] || []).find(field => field.name === name);
  if (!found) {
    return false; // si no encontrado (nuevo campo por ejemplo), no lo escondemos
  }
  return found.hide;
}

export function isLastVisibleField(registerName) {
  const hiddens = this.state[registerName].filter(field => field.hide);
  return this.state[registerName].total - hiddens.length <= 1;
}

export function updateStateField(registerName, name, hide) {
  const index = this.state[registerName].findIndex(field => field.name === name);
  const found = index === -1 ? null : this.state[registerName][index];
  if (!found) {
    if (hide) {
      this.state[registerName].push({ name, hide });
    } /* else no existe y por defecto es hide=true */
  } else {
    found.hide = hide;
  }

  this.events.emit('ecFormBuilder:state', this.state);
}

export function updateStateSection(name, isOpen) {
  const section = this.state.root.find(item => item.name === name);
  if (!section || section.open === isOpen) {
    return;
  }
  section.open = isOpen;
  this.events.emit('ecFormBuilder:state', this.state);
}

export function setStateSection(name, state) {
  this.state[name] = state;
  this.events.emit('ecFormBuilder:state', this.state);
}

export function updateStateColumn(registerName, name, hide) {
  const found = this.state[registerName].find(field => field.name === name);
  if (!found) {
    this.state[registerName].push({ name, hide, width: 200 });
  } else {
    found.hide = hide;
  }

  this.events.emit('ecFormBuilder:state', this.state);
}

export function udpateStateRegister(registerName, state) {
  const total = this.state[registerName].total;
  const isTypeGrid = this.state[registerName].isTypeGrid;
  this.state[registerName] = state;
  this.state[registerName].total = total;
  this.state[registerName].isTypeGrid = isTypeGrid;
  this.events.emit('ecFormBuilder:state', this.state);
}
